import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Fade,
  Backdrop,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";

export default function OrderConfirmationModal({
  open,
  handleClose,
  orderId,
  onViewOrder,
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "90%" : 380,
    maxWidth: 420,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 3,
    p: isMobile ? 3 : 4,
    textAlign: "center",
  };

  return (
    <Modal
      open={open}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 300 } }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <CheckCircleIcon
            sx={{
              fontSize: isMobile ? 50 : 60,
              color: "success.main",
              mb: 1,
            }}
          />

          <Typography
            variant={isMobile ? "subtitle1" : "h6"}
            sx={{ fontWeight: 700, mb: 1 }}
          >
            {t("Order Confirmed")}
          </Typography>

          <Typography
            variant="body2"
            sx={{ mb: 2, color: "text.secondary" }}
          >
            {t("Thank you for your purchase")}
          </Typography>

          {orderId && (
            <Typography
              variant="body2"
              sx={{ mb: 3, fontWeight: 500, color: "primary.main" }}
            >
              {t("Order")} #{orderId}
            </Typography>
          )}

          <Button
            variant="contained"
            fullWidth
            sx={{ mb: 1, py: 1.2, textTransform: "none" }}
            onClick={onViewOrder}
          >
            {t("View Order")}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            sx={{ py: 1.2, textTransform: "none" }}
            onClick={handleClose}
          >
            {t("Continue Shopping")}
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
}
